/**
 * WebSocket message type (group events by category).
 */
export enum WSMessageType {
  entityIdChanged = 'entityIdChanged',
  entityCreated = 'entityCreated',
  entitySkippedAsNoLicense = 'entitySkippedAsNoLicense',
}

export enum WSEntityType {
  user = 'user',
  pair = 'pair',
}

export type WSEntityIdChangedMsg = {
  entityType: WSEntityType;
  entityId: string;
};

export type WSEntityCreatedMsg<T = any> = {
  entityType: WSEntityType;
  entity: T;
};

export type WSEntitySkippedAsNoLicenseMsg = {
  entityType: WSEntityType;
  pairName: string;
};

export type WSConnectionStatus = 'connecting' | 'connected' | 'disconnected' | 'error';
